import { createUseStyles } from 'react-jss';

export const MainLayoutStyle = createUseStyles({
    headerStyle: {
        color: '#fff',
        height: 64,
        backgroundColor: 'white',
    },
    contentStyle: {
        minHeight: 120,
        backgroundColor: 'white',
    },
    footerStyle: {
        textAlign: 'center',
        color: 'white',
        backgroundColor: '#454f97',
    },
    logoStyle: {
        height: 48,
        width: 148,
        marginTop: 12,
        marginRight: 24,
        float: 'left',
    },
    containerStyle: {
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingBottom: 50,
        paddingRight: 15,
        paddingLeft: 15,
        '@media (min-width: 476px)': {
            paddingRight: 15,
            paddingLeft: 15,
        },
        '@media (min-width: 768px)': {
            paddingRight: 15,
            paddingLeft: 15,
        },
        '@media (min-width: 992px)': {
            paddingRight: 15,
            paddingLeft: 15,
        },
        '@media (min-width: 1200px)': {
            paddingRight: 15,
            paddingLeft: 15,
        },
        '@media (min-width: 1400px)': {
            width: 1340,
            maxWidth: '100%',
        },
    },
});
